import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { profileFormService } from "../../services/profile-form.service";

export const readProfileFormByProfileId = createAsyncThunk(
  "profileFormManage/readProfileFormByProfileId",
  async (profileId, { rejectWithValue }) => {
    try {
      const response = await profileFormService.readProfileFormByProfileId(
        profileId
      );

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addProfileForm = createAsyncThunk(
  "profileFormManage/addProfileForm",
  async (data, { rejectWithValue }) => {
    try {
      const response = await profileFormService.addProfileForm(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editProfileForm = createAsyncThunk(
  "profileFormManage/editProfileForm",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await profileFormService.editProfileForm(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeProfileForm = createAsyncThunk(
  "profileFormManage/removeProfileForm",
  async (id, { rejectWithValue }) => {
    try {
      const response = await profileFormService.removeProfileForm(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
